import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { ModalInfoPromotionV2 } from "../../../components/common/ModalInfoPromotionV2";
import { imgTema2 } from "../../../assets/tema2";
import { useNavigate } from "react-router-dom";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	panelCondimentero: 3,
	panelSalchicas: 4,
	panelVerduras: 5,
	panelRoller: 6,
	panelTrapo: 7,
	panelPinzas: 8,
	dialogTwo: 9,
	win: 10
};

const stepPanel = {
	"Condimentero": steps.panelCondimentero,
	"Salchichas": steps.panelSalchicas,
	"Contenedor_verduras": steps.panelVerduras,
	"Cepillo": steps.panelRoller,
	"Trapo": steps.panelTrapo,
	"Pinzas": steps.panelPinzas,
}

export const Team2SubtopicOneActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema1], 3);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 1 act 3');
			ObserverEmitter.emit(EVENTS.team2.subtopicOne.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub01.sub1_act3_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicOne.activityThree.finishAnimation, (stepName = "") => {
		const findStep = stepPanel[stepName]
		if (!findStep) {
			return
		}
		setUiToShow(findStep)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === -2 && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 3: Máquina de capuchino Componentes" />
					<DialogBarNew
						dialog={
							" Es importante conocer los utensilios dentro de tu área de servicio, ¡vamos a ver más de cada uno de ellos!"
						}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Operación de Roller"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.moveToTableCoffe)
							setUiToShow(-2);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.panelCondimentero && (
				<>
					<ModalInfoPromotionV2
						title={"Condimento Escalonado."}
						description={"El condimento escalonado con tapas le permitirá a los clientes tener la facilidad de tomar lo que requieren para aderezar y complementar su delicioso hot dog."}
						url={imgTema2.Condimento_Escalonado}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.viewObjectsOnly, "Salchichas")
							setUiToShow(-1);
						}}
					/>
				</>
			)}
			{uiToShow === steps.panelSalchicas && (
				<>
					<ModalInfoPromotionV2
						title={"Contenedor de Salchichas."}
						description={"El contenedor de salchichas debe estar siempre limpio y con la cantidad mínima señalada de salchichas. De igual manera recuerda que no deben estar más de 4 horas."}
						url={imgTema2.Contenedor_Salchichas}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.viewObjectsOnly, "Contenedor_verduras")
							setUiToShow(-1);
						}}
					/>
				</>
			)}
			{uiToShow === steps.panelVerduras && (
				<>
					<ModalInfoPromotionV2
						title={"Contenedor de Verduras."}
						description={"El contenedor de verduras debe estar siempre a la mitad de su capacidad, para evitar tener mermas."}
						url={imgTema2.Contenedor_Verduras}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.viewObjectsOnly, "Cepillo")
							setUiToShow(-1);
						}}
					/>
				</>
			)}
			{uiToShow === steps.panelRoller && (
				<>
					<ModalInfoPromotionV2
						title={"Cepillo para Roller."}
						description={"El cepillo para roller debes usarlo para limpiar de manera adecuada y frecuente la zona donde estarán las salchichas. Recuerda que una buen higiene invita a los clientes a seguir consumiento."}
						url={imgTema2.Cepillo_Roller}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.viewObjectsOnly, "Trapo")
							setUiToShow(-1);
						}}
					/>
				</>
			)}
			{uiToShow === steps.panelTrapo && (
				<>
					<ModalInfoPromotionV2
						title={"Trapo Azul"}
						description={"El trapo azul te ayudará dentro de tus funciones de limpieza, después de su uso debes sanitizarlo."}
						url={imgTema2.Trapo_Azul}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.viewObjectsOnly, "Pinzas")
							setUiToShow(-1);
						}}
					/>
				</>
			)}
			{uiToShow === steps.panelPinzas && (
				<>
					<ModalInfoPromotionV2
						title={"Pinzas para Salchicha"}
						description={"Las pinzas para salchicha es muy importante dejarlas a plena vista para que el cliente pueda tenerlas a la mano, y revisar que este siempre limpia."}
						url={imgTema2.Pinzas_Salchicha}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub01.sub1_act3_a02T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.moveInitActThree)
							setUiToShow(steps.dialogTwo);
						}}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"¡Excelente trabajo! Es muy importante comprender el porqué de cada utensilio."
						}
						percentage={"20%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Cada utensilio es fundamental para la venta y para los clientes."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema2.activities.subtema1,
								})
							);
							navigator("/home2/tema2/subtema1/activityresult");
						}}
					/>
				</>
			)}
		</>
	);
};
